import { cn } from '~/shadcn/lib/utils'
import { Spinner } from '~/shadcn/ui/spinner'
import { Text } from '~/@mid_ui/typography/Text'
import { useUser } from '~/@biz_account/useUser/useUser'
import { BackButton } from '~/@pages_investing/project-detail/project-detail_ui/back-button/BackButton'
import { WalletInfo } from './WalletInfo'
import { WithdrawFundsForm } from './WithdrawFundsForm'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'

export function WithdrawFunds() {
  const { user } = useUser()

  if (user == null || user.investorWallet == null)
    return <Spinner className="size-4" />

  return (
    <div className="flex flex-col items-center w-full">
      <div
        className={cn(
          'flex flex-col gap-10 max-w-[600px] w-full items-baseline',
          'py-10 lg:px-0 lg:py-10'
        )}>
        <BackButton className="text-primary" />

        <div className="flex flex-col gap-5">
          <HeadingTwo>Výber fin. prostriedkov</HeadingTwo>
          <Text className="font-semibold">
            Preveďte peniaze na svoj účet prostredníctvom jednoduchého bankového
            prevodu.
          </Text>
        </div>

        <WalletInfo wallet={user.investorWallet} />
        <WithdrawFundsForm
          wallet={user.investorWallet}
          bankAccounts={user.profile?.bankAccounts ?? []}
        />
      </div>
    </div>
  )
}
